import styled from 'styled-components';

/**
 * style for the IMG tag, it always just fills its container.
 * NOTE: The currently used version of styled components does not recognize the `loading` attribute on IMG tags.
 *       We make it a custom attribute AND ts-ignore to pass lint checks
 */

var StyledImg = styled.img.attrs(function (props) {
  return {
    loading: props.loading
  };
}).withConfig({
  displayName: "styles__StyledImg",
  componentId: "sc-1322bgy-0"
})(["width:100%;height:100%;"]);

export { StyledImg };
